import React from 'react';
import ReactDOM from 'react-dom';
import 'rc-pagination/assets/index.css';
import 'react-rater/lib/react-rater.css';
import ReviewForm from './ReviewForm';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {theme} from '../../styles';

export default options => {
    ReactDOM.render(
        <MuiThemeProvider theme={theme}>
            <ReviewForm
                initialNotes={options.reviewText}
                initialRating={options.stars}
                reviews={options.reviews}
                regionId={options.regionId}
                userId={options.user.id}
            />
        </MuiThemeProvider>,
        window.document.querySelector(options.selectors.reviewForm)
    );
};
